export const SiteParams = [
  { URI: "", url: "/", value: "AUD", code: "AUS", cms:"staycations" },
  { URI: "us", url: "/us", value: "USD", code: "US", cms:"staycationsUS"},
]
